import { render } from "./LoginMondiaUser.vue?vue&type=template&id=db8c861e"
import script from "./LoginMondiaUser.vue?vue&type=script&lang=js"
export * from "./LoginMondiaUser.vue?vue&type=script&lang=js"

import "./LoginMondiaUser.vue?vue&type=style&index=0&id=db8c861e&lang=css"

import exportComponent from "/var/jenkins_home/workspace/Imanyat-Egypt-Systech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__